export const ariaError = (state: UI.FormfieldState, name: string, id: string): string | null => {
	return state?.hasError ? name + id : null;
};
